import React, { FC } from 'react';
import ExpenseCategoryAdditionalInfoPopup from './ExpenseCategoryAdditionalInfoPopup';

const CapExAdditionalInfoPopup: FC<any> = (props): React.ReactElement => {
	return <ExpenseCategoryAdditionalInfoPopup categoryType="capex" {...props} />;
};

export default CapExAdditionalInfoPopup;
